module.exports = __webpack_public_path__ + "static/media/icon-bancnet.9e2647bd.png";